export default __webpack_public_path__ + "static/onion-d71f530b47d77ec04b50032b091f287f.png";